import React from 'react';
import { siteContent } from '../data/mock';

const ProblemSection = () => {
  const { problem } = siteContent;

  return (
    <section className="problem-section section-padding" data-testid="problem-section" data-reveal="rise">
      <div className="container">
        <h2 className="section-title-center" data-testid="problem-title">{problem.title}</h2>
        <p className="problem-introduction">{problem.introduction}</p>

        <div className="problem-cards">
          {problem.points.map((point, index) => (
            <div key={index} className="problem-card" data-testid={`problem-card-${index}`}>
              <h3 className="problem-card-title">{point.title}</h3>
              <p className="problem-card-description">{point.description}</p>
            </div>
          ))}
        </div>

        <div className="problem-conclusion" data-testid="problem-conclusion">
          <p>{problem.conclusion}</p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
